
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.787 0A1.8 1.8 0 000 1.791v10.857c0 .98.808 1.785 1.783 1.791l1.799.012.006 2.885a.666.666 0 001.064.531l4.565-3.408 6.998-.02A1.802 1.802 0 0018 12.65V1.79A1.8 1.8 0 0016.213 0H1.787zm0 1.332h14.426c.262 0 .455.193.455.459v10.857a.444.444 0 01-.457.46l-7.219.019a.666.666 0 00-.396.133l-3.678 2.746-.004-2.219a.666.666 0 00-.664-.664l-2.459-.016a.444.444 0 01-.459-.459V1.791c0-.266.193-.459.455-.459z","font-family":"sans-serif","overflow":"visible","paint-order":"markers stroke fill"}}),_c('path',{attrs:{"d":"M8.713 11.604a.905.905 0 01-.72-.98c.076-.896 1.271-1.171 1.752-.405.177.282.141.832-.069 1.056-.27.289-.617.408-.963.329zm-.288-2.551c-.605-.369-.332-1.813.478-2.537l.707-.634c.668-.599.824-.863.79-1.338-.031-.428-.228-.725-.617-.932-.353-.188-1.13-.194-1.442-.012-.297.174-.567.552-.765 1.073-.098.257-.253.53-.367.644-.166.167-.24.198-.482.198-.371 0-.611-.146-.767-.467-.108-.224-.116-.3-.062-.592.188-1.014 1.029-1.868 2.168-2.2.493-.145 1.508-.148 2.04-.007.501.131 1.142.51 1.434.845.125.142.309.433.41.647.16.335.185.457.185.894 0 .797-.129 1.009-1.331 2.19-.953.935-.997.988-1.093 1.34-.186.676-.222.758-.378.881-.205.161-.65.164-.908.007z"}})])
          )
        }
      }
    